module.exports = __webpack_public_path__ + "img/solution-icon-3.570004da.png";